import styled from "styled-components";

const LoaderStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
  width: 100%;
  z-index: 20;

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
`;
export default LoaderStyled;
